import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(_component_RouterLink, { to: _ctx.to }, {
    default: _withCtx(() => [
      _createElementVNode("li", {
        class: _normalizeClass(["menu-item", { active: _ctx.active }])
      }, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.icon), { class: "icon" })),
        _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t(_ctx.label)), 1)
      ], 2)
    ]),
    _: 1
  }, 8, ["to"]))
}